<template lang="pug">
  #plan_select_register
    .form-group.row
      label.col-sm-4.col-form-label プラン名
      .col-sm-8
        .mt-2(v-if="read_only") {{ selectedPlanDisplayName }}
        label.selectbox-001.mb-0(v-else)
          select.form-control(v-if="sign_up_type == 'f3'" v-model="selectedPlanName" @change="findPlan" name="plan_name")
            option(value="master") Master （初月無料・初月解約可）
          select.form-control(v-else v-model="selectedPlanName" @change="findPlan" name="plan_name")
            option(v-if="isFreeShow && sign_up_type == 'f1'" value="") フリー(クレジットカード登録不要)
            option(v-else-if="isFreeShow" value="") Free（クレジットカード登録不要）
            option(v-for="plan in uniquePlans" :value="plan.name" :key="plan.name") {{ plan.display_name }}
              span(v-if="coupon != '' && plan.name == 'master'") （初月無料・初月解約可）
        div
          small ヒートマップPV数：{{ heatmapPV }}
        div
          small ポップアップ・オーバーレイPV数：{{ popUpPV }}
        input(type="hidden", name="coupon_code", :value="couponCode")
    .form-group.row
      label.col-sm-4.col-form-label 支払期間
      .col-sm-8
        .mt-2(v-if="read_only") {{ selectedIntervalDisplay }}
        label.selectbox-001.mb-0(v-else)
          select.form-control(v-model="selectedInterval" @change="findPlan" name="plan_interval_count")
            option(v-if="selectedPlanName != ''" value="") 選択してください
            option(v-else value="") 選択不要
            option(v-if="coupon != '' && selectedPlanName == 'master'" :value="1" ) 1ヶ月払い
            option(v-else-if="selectedPlanName != ''" v-for="interval in intervals" :value="interval.interval" :key="`interval-${interval.interval}`") {{ interval.display }}
        div(v-if="!read_only && selectedPlanName != '' && selectedInterval== ''")
          small.text-danger ※支払期間を選択してください。
    .form-group.row
      label.col-sm-4.col-form-label 月額料金
      .col-sm-8.mt-2 {{ monthlyPrice }}
        span.ml-2(v-if="coupon != '' && selectedPlanName == 'master'") ※2ヶ月目以降

    .form-group.row.mb-0(v-if="sign_up_type == 'f2'")
      label.col-sm-4.col-form-label ご請求金額
      .col-sm-8.mt-2 0円
        div
          small ※申込から30日後、選択したプランが適用されます。<br>※無料期間中に解約すると費用は一切発生しません。<br>※解約は管理画面から、いつでも対応可能です。
    .form-group.row.mb-0(v-else-if="sign_up_type == 'f3'")
      label.col-sm-4.col-form-label ご請求金額
      .col-sm-8.mt-2 0円
        div
          small ※申込から30日間分の無料クーポンが適用されます。<br>※無料期間中に解約すると費用は一切発生しません。<br>※解約は管理画面から、いつでも対応可能です。
    .form-group.row.mb-0(v-else)
      label.col-sm-4.col-form-label ご請求金額
      .col-sm-8 {{ totalAmount }}
  </template>

  <script>
  import Vue from 'vue'

  export default {
    props: {
      plans: { type: String, default: () => [] },
      default_plan_name: {type: String, default: ""},
      default_interval: { type: [String, null], default: null },
      coupon: {type: String, default: ""},
      is_free_show: { type: [Boolean, null], default: true },
      sign_up_type: {type: String, default: ""},
      read_only: { type: Boolean, default: false },
    },
    data() {
      return {
        plans_ary : [],
        selectedPlanName: "",
        selectedInterval: '',
        uniquePlans: [],
        selectedPlan: null,
        isFreeShow: null,
        intervals: [
          {interval : 36 , display: '3年払い（50% OFF）'},
          {interval : 12 , display: '1年払い（25% OFF）'},
          {interval : 1 , display: '1ヶ月払い'},
        ],
      };
    },
    computed: {
      heatmapPV() {
        if (!this.selectedPlanName) {
          return (1000).toLocaleString('ja-JP')
        } else {
          let plan = this.plans_ary.find((plan) => {
            return plan.name === this.selectedPlanName
          });
          return plan.heatmap_imp_limit.toLocaleString('ja-JP') + '／月'
        }
      },
      popUpPV() {
        if (!this.selectedPlanName) {
          return (1000).toLocaleString('ja-JP')
        } else {
          let plan = this.plans_ary.find((plan) => {
            return plan.name === this.selectedPlanName
          });
          return plan.pop_up_imp_limit.toLocaleString('ja-JP') + '／月'
        }
      },
      monthlyPrice() {
        if (!this.selectedPlan) {
          return "0円";
        }
        if(this.selectedPlan.interval == "month"){
          if(this.selectedPlan.interval_count == 1){
            return "税込 " + this.selectedPlan.amount.toLocaleString('ja-JP') + "円/月"
          } else if(this.selectedPlan.interval_count == 36) {
            return "税込 " + parseInt(this.selectedPlan.amount/36).toLocaleString('ja-JP') + "円 x 36ヶ月";
          } else {
            return "税込 " + parseInt(this.selectedPlan.amount/this.selectedPlan.interval_count).toLocaleString('ja-JP') + "円 x " + this.selectedPlan.interval_count + "ヶ月";
          }
        } else {
          return "税込 " + parseInt(this.selectedPlan.amount/12).toLocaleString('ja-JP') + "円 x 12ヶ月";
        }
      },
      couponCode() {
        return this.$store.state.user.coupon_code
      },
      selectedPlanDisplayName() {
        if (this.sign_up_type == 'f3') {
          return 'Master （初月無料・初月解約可）'
        }
        const plan = this.uniquePlans.find((p) => {
          return p.name === this.selectedPlanName
        })
        if (!plan) {
          return this.selectedPlanName
        }
        if (this.coupon != '' && plan.name == 'master') {
          return plan.display_name + '（初月無料・初月解約可）'
        }
        return plan.display_name
      },
      selectedIntervalDisplay() {
        if (this.coupon != '' && this.selectedPlanName == 'master') {
          return '1ヶ月払い'
        }
        const interval = this.intervals.find((item) => {
          return item.interval == this.selectedInterval
        })
        return interval ? interval.display : ''
      },
      totalAmount() {
        if (!this.selectedPlan) {
          return "0円";
        } else if (this.coupon != ''  && this.selectedPlanName == 'master') {
          // クーポンが選択されてるユーザーかつmasterプランを選択している場合
          return "0円";
        }
        if(this.selectedPlan.interval == "month"){
          if(this.selectedPlan.interval_count == 1){
            return "税込 " + this.selectedPlan.amount.toLocaleString('ja-JP') + "円"
          } else if(this.selectedPlan.interval_count == 3) {
            return "税込 " + this.selectedPlan.amount.toLocaleString('ja-JP') + "円"
          } else {
            return "税込 " + this.selectedPlan.amount.toLocaleString('ja-JP') + "円"
          }
        } else {
          return "税込 " + this.selectedPlan.amount.toLocaleString('ja-JP') + "円"
        }
      },
    },
    methods: {
      setPlans() {
        const uniqueNames = Array.from(new Set(this.plans_ary.map(plan => plan.name)));
        const filteredNames = uniqueNames.filter(name => {
          // Premiumプランは常に非表示
          return name != "premium";
        });
        const uniquePlans = filteredNames.map(name => {
          const correspondingPlan = this.plans_ary.find(plan => plan.name === name);
          // ｐｙｈランカタカナ
          var displayName = correspondingPlan ? correspondingPlan.display_name : ""
          if (this.sign_up_type == "f1" || this.sign_up_type == "f2") {
            var prefix =  (this.sign_up_type == "f2")? "（30日無料）" : ""
            if (name == 'basic') {
              displayName = 'ベーシック'+prefix;
            } else if (name == 'master') {
              displayName = 'マスター'+prefix;
            } else if (name == 'enterprise') {
              displayName = 'エンタープライズ'+prefix;
            }
          }
          return {
            name: name,
            display_name: displayName,
          };
        });

        this.uniquePlans = uniquePlans;
      },
      async checkCoupon(){
        const data = await this.$store.dispatch("user/checkCouponExists", this.coupon)
        if (data.error) {
          // 存在してない場合は初月無料クーポンを適用
          this.$store.commit("user/setCouponName", 'Master（初月無料・初月解約可）')
          this.$store.commit("user/setCouponCode", 'master_zero')
        } else {
          this.$store.commit("user/setCouponName", data['name'])
          this.$store.commit("user/setCouponCode", this.coupon)
        }
      },
      findPlan(){
        // クーポンが選択されてるユーザーかつmasterプランを選択しているユーザーは１ヶ月払いのみ
        if (this.coupon != '' && this.selectedPlanName == 'master') {
          this.selectedInterval = 1
        }
        if (!this.selectedPlanName || !this.selectedInterval) {
          this.selectedPlan = null;
          this.selectedInterval = '';
          this.$store.commit("user/setPlanToChange", {})
          this.$store.commit("user/setCouponName", '')
          this.$store.commit("user/setCouponCode", '')
        } else {
          this.selectedPlan = this.plans_ary.find((plan) => {
            if (this.selectedInterval == 12) {
              return plan.name === this.selectedPlanName && plan.interval === 'year'
            } else if (this.selectedInterval == 36) {
              return plan.name === this.selectedPlanName && plan.interval === 'month' && plan.interval_count === 36
            } else {
              return plan.name === this.selectedPlanName && plan.interval === 'month' && plan.interval_count === this.selectedInterval
            }
          });
          this.$store.commit("user/setPlanToChange", this.selectedPlan)
          if (this.coupon != '' && this.selectedPlanName == 'master') {
            // クーポン情報取得
            this.checkCoupon()
          } else {
            this.$store.commit("user/setCouponName", '')
            this.$store.commit("user/setCouponCode", '')
          }
        }
      },
    },
    mounted() {
      this.isFreeShow = this.is_free_show
      // プランに変更します。 ラベル隠す
      this.$store.commit("user/sethideChangeLabel", true)
      this.plans_ary = JSON.parse(this.plans)
      // 初期化時にも uniquePlans を設定
      this.setPlans();
      // ABテスト
      if (this.sign_up_type == "f1") {
        this.intervals = [
          {interval : 36 , display: '3年払い（50% OFF）'},
          {interval : 12 , display: '1年払い（25% OFF）'},
          {interval : 1 , display: '1ヶ月払い'},
        ]
      } else if(this.sign_up_type == "f2") {
        this.isFreeShow = false
        this.intervals = [
          {interval : 36 , display: '3年払い（50% OFF）'},
          {interval : 12 , display: '1年払い（25% OFF）'},
          {interval : 1 , display: '1ヶ月払い'},
        ]
        // 初期値
        this.selectedPlanName = 'basic'
        this.selectedInterval = 1
      } else if(this.sign_up_type == "f3") {
        this.intervals = [
          {interval : 1 , display: '1ヶ月払い'},
        ]
        // 初期値
        this.selectedPlanName = 'master'
        this.selectedInterval = 1
      }
      // すでにプランが選択されている場合
      if(this.default_plan_name != "") this.selectedPlanName = this.default_plan_name
      if(this.default_interval != "") this.selectedInterval = Number(this.default_interval)
      this.findPlan()
    },
  }
  </script>
  <style lang="scss" scoped>
  .selectbox-001 {
      position: relative;
      width: 100%;
  }
  .selectbox-001::before,
  .selectbox-001::after {
      position: absolute;
      content: '';
      pointer-events: none;
  }
  .selectbox-001::before {
      display: inline-block;
      right: 0;
      width: 2.8em;
      height: 2.8em;
      border-radius: 0 3px 3px 0;
      background-color: #5F5F5F;
  }
  .selectbox-001::after {
      position: absolute;
      top: 50%;
      right: 1.4em;
      transform: translate(50%, -50%) rotate(45deg);
      width: 6px;
      height: 6px;
      border-bottom: 3px solid #fff;
      border-right: 3px solid #fff;
  }
  .selectbox-001 select {
      appearance: none;
      min-width: 230px;
      height: 2.8em;
      padding: .4em 3.6em .4em .8em;
      border: none;
      border-radius: 3px;
      background-color: #e6edf3;
      color: #333;
      font-size: 1em;
      cursor: pointer;
  }
  .selectbox-001 select:focus {
      outline: 2px solid #5F5F5F;
  }
  </style>
